export default __webpack_public_path__ + "static/media/hiltonFarmsDesktop.9225077b.jpg";